<!--
 * @Author: Ztq
 * @Date: 2022-11-29 16:27:24
 * @LastEditors: 景 彡
 * @LastEditTime: 2022-12-02 17:48:27
 * @Description: 
 * @FilePath: \ch2-vue-components\lib\button\src\Button.vue
-->
<script lang="ts" setup>
import { Button } from 'ant-design-vue';
import { useAttrs, useSlots } from 'vue';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';
import useSlot from '../../hooks/useSlot';
import type { IButtonProps } from '../types';
import useFormReadOnly from '../../hooks/useFormReadOnly';

const { useExcludeSlots } = useSlot({ slots: useSlots() });

const { getBindValue } = useForm<IButtonProps>({ props: null, componentName: 'button', attrs: useAttrs() });

useFormReadOnly(getBindValue);
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <Button v-bind="getBindValue">
    <template v-for="(slot, key) in useExcludeSlots" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </Button>
</template>
